import React, { useState } from "react";

import { GenericModal } from "components/GenericModal";
import { createMetaCustomAudience } from "helpers/destinations/createDestination";

import Content from "./components/Content";
import Footer from "./components/Footer";

const CreateMetaCustomAudience = ({
    data,
    dispatchCloseModal,
    dispatchClearModalState,
    dispatchSetModalData,
}) => {
    const { partnerInstalID, adAccountID } = data;
    const [loading, setLoading] = useState(false);
    const [name, setName] = useState("");
    const [retentionDays, setRetentionDays] = useState("forever");

    const handleClose = () => {
        if (loading) return;
        dispatchCloseModal();
    };

    const onSubmit = async () => {
        setLoading(true);
        const response = await createMetaCustomAudience({
            name,
            partner_install_id: partnerInstalID,
            ad_account_id: adAccountID,
            retention_days: retentionDays,
        });
        if (response.status) {
            dispatchClearModalState();
            dispatchSetModalData({
                customAudienceID: response?.data?.[0]?.partner_reference_id,
            });
        }
        setLoading(false);
    };

    return (
        <GenericModal
            open
            onClose={handleClose}
            title="Create META Custom Audience"
            maxWidth="sm"
            fullWidth
            fixedHeight="auto"
            disableEscapeKeyDown={loading}
            content={
                <Content
                    name={name}
                    setName={setName}
                    retentionDays={retentionDays}
                    setRetentionDays={setRetentionDays}
                />
            }
            footer={
                <Footer
                    name={name}
                    onSubmit={onSubmit}
                    onClose={handleClose}
                    loading={loading}
                />
            }
        />
    );
};

export default CreateMetaCustomAudience;
